import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CalendarContextService {
  private readonly key = 'calendarId';

  constructor(private router: Router) {
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => {
        const id = this.findParam(this.router.routerState.snapshot.root, 'calendarId');
        if (id) sessionStorage.setItem(this.key, id);
      });
  }

  getCalendarId(): string | null {
    const id = this.findParam(this.router.routerState.snapshot.root, 'calendarId');
    return id ?? sessionStorage.getItem(this.key);
  }

  private findParam(route: ActivatedRoute['snapshot'], name: string): string | null {
    let cur: ActivatedRoute['snapshot'] | null = route;
    while (cur) {
      if (cur.params?.[name]) return cur.params[name];
      cur = cur.firstChild ?? null;
    }
    return null;
  }
}


